export default class CreateDiscountTemplateRequest {
    public discountName: string = "";
    public organizationContractId: string | null = null;
    public constructionSiteId?: string | null = null;
    public sourceDiscountId?: string | null = null;
    public overallDiscountPercentage?: number = 0.0;
}